export default {

  global: {
    noLimit: '您没有权限执行此操作，请联系管理员为您添加权限',
  },
  text: {
    lang: 'zh',
    title: '京东云控制台',
    cabinet: '机柜',
    status: '状态',
    submission: '提交',
    operate: '操作',
    confirm: '确定',
    cancel: '取消',
    equipment: '设备',
    brand: '品牌',
    model: '型号',
    belongUbit: '所在U位',
    note: '备注',
    roomNum: '房间号',
    Telecom: '电信单线',
    Unicom: '联通单线',
    Mobile: '移动单线',
    rackUIndex: '所在U位',
    normal: '正常',
    bandWidth: '带宽',
    fullName: '姓名',
    enclosure: '附件',
    tel: '电话',
    email: '邮箱',
    check: '查看',
    checkDetail: '查看详情',
    viewMore: '查看更多',
    revoke: '撤销',
    revokeVerb: '撤销',
    verify: '核验',
    closeTicket: '关单',
    abnormal: '异常',
    pass: '通过',
    turnDown: '驳回',
    turnDownReason: '驳回原因',
    reject: '拒绝',
    overview: '概览',
    notPower: '未加电',
    power: '已加电',
    inWarehouse: '已入库',
    onShelf: '已上架',
    bgp: 'BGP',
    dynamicBGP: '动态BGP',
    thirdLineBGP: '三线BGP',
    noSearch: '暂无数据',
    noAbnormal: '暂无异常',
    noTicket: '暂无需求处理的工单',
    hasSearch: '没有找到相关结果，请重新搜索',
    setNow: '立即设置',
    noSetRuleTip: '暂未设置报警规则',
    delete: '删除',
    saveDraft: '保存草稿',
    submissionNow: '立即提交',
    editDraft: '请填写工单信息后再进行保存。',
    draftTips: '工单草稿最多保存7天，7天后此草稿自动删除',
    sureDelete: '确认删除',
    draftTicket: '此草稿中的工单',
    Maximum500: '最大500条',
    entrancePurpose: '入室目的',
    reasonInfo: '入室原因',
    choose: '请选择{0}',
    moreNode: '更多托管区',
    resourceBill: '资源账单',
    productType: '产品类型',
    paymentMethod: '付款方式',
    currency: '币种',
    accountPeriod: '账期',
    search: '查询',
    reset: '重置',
    expand: '展开',
    collapse: '收起',
    totalCost: '费用总计',
    export: '导出',
    totalCostTip: '原价+调整金额',
    costTime: '消费时间',
    price: '单价',
    dosage: '用量',
    changeCalValue: '调整量',
    dosageUnit: '用量单位',
    charge: '费用',
    all: '全部',
    postpaid: '后付费',
    noBillinginformation: '无账单信息',
    OriginalPrice: '原价',
    AdjustedAmount: '调整金额',
    regionInspection: '机房巡检',
    deviceInspection: '设备巡检',
    inspectionDate: '巡检日期',
    inspectionTime: '巡检时间',
    temperatureValue: '温度数值（℃）',
    humidityValue: '湿度数值（%）',
    arrangementOfArticles: '物品摆放',
    waterLeakage: '漏水',
    accessControl: '门禁',
    securityMonitoring: '安防（监控）',
    fireProtection: '消防',
    lightningProtection: '防雷',
    airConditioning: '空调',
    powerSupply: '供电',
    physicalEnvAbnormality: '物理环境异常描述',
    faultType: '故障类型',
    tags: '标签',
    editTag: '编辑标签',
    goMonitor: '查看监控',
    pleaseSelectResource: '请选择资源',
    id: 'ID',
    applyId: '提单人ID',
    start_placeholder: '开始日期',
    end_placeholder: '结束日期'
  },

  // 机房相关
  idcs: {
    title: '机房',
    idcName: '机房名称',
    region: '托管区',
    address: '地址',
    managerPhone: '值班电话',
    exportCsvName: '机房列表.csv'
  },

  // 专线相关
  directConnects: {
    title: '专线',
    directConnectId: 'ID',
    directConnectName: '专线名称',
    datacenterNameA: 'A端机房名称',
    datacenterNameB: 'B端机房名称',
    resourceType: '资源类型',
    resourceUsage: '资源用量',
    billingInfo: '计费信息',
    billingTime: '计费时间',
    expireTime: '到期时间',
    inputName: '请输入专线名称',
    inputId: '请输入ID',
    inputARoomName: '请输入A端机房名称',
    inputBRoomName: '请输入B端机房名称',
    chooseResourceType: '请选择资源类型',
    exportCsvName: '专线列表.csv'
  },

  // 其他资源相关
  otherResource: {
    title: '其他资源',
    id: 'ID',
    name: '资源名称',
    idcName: '机房名称',
    region: '托管区',
    resourceType: '资源类型',
    resourceUsage: '资源用量',
    billingInfo: '计费信息',
    billingTime: '计费时间',
    expireTime: '到期时间',
    inputName: '请输入资源名称',
    inputId: '请输入ID',
    inputIdcName: '请输入机房名称',
    chooseResourceType: '请选择资源类型',
    chooseRegion: '请选择托管区',
    exportCsvName: '其他资源列表.csv',
    // 搜索placeholder
    searchPlaceholder: {
      name: '请输入资源名称搜索',
      id: '请输入ID搜索',
      idcName: '请输入机房名称搜索'
    }
  },

  cabinet: {
    cabinetView: '机柜视图',
    cabinetNumCode: '机柜编码',
    roomName: '机房名称',
    cabinetType: '机柜类型',
    billingType: '计费类型',
    EnablingStatus: '开通状态',
    EnablingTime: '开通时间',
    billingInfo: '计费信息',
    billingTime: '计费时间',
    cabinetSpace: '机柜空间(U)',
    rentingTime: '起租时间',
    expireTime: '到期时间',
    reserveStartTime: '预留开始时间',
    reserveEndTime: '预留结束时间',
    powerUpStatus: '加电状态',
    cabinetLockStatus: '机柜锁定',
    cabinetDetail: '机柜详情',
    occupyU: '占用U数(U)',
    freeU: '空闲U数(U)',
    current: '电流(A)',
    currentNoUnit: '电流',
    ratedCurrent: '额定电流(A)',
    helpDoc: '{0}帮助文档',
    realTimeCurrent: '实时电流(A)',
    utilizationRate: '使用率',
    resourceInformation: '资源信息',
    dynamicInformation: '动环信息',
    rangeForSearch: '选择查询的日期范围',
    start_placeholder: '开始日期',
    end_placeholder: '结束日期',
    rangeH: '{0}小时',
    rangeD: '{0}天',
    rangeSeparator: ' 至 ',
    powerTrendChart: '机柜电流趋势图',
    period: '周期',
    maxDays: '（最多连续查询 {0} 天数据）'
  },

  ip: {
    ipAmount: 'IP地址数量',
    ipType: 'IP类型',
    IPV4: 'IPV4',
    IPV6: 'IPV6',
    freeQuantity: '免费数量',
    ipAddress: 'IP地址',
    publicNetIp: '公网IP',
    netWorkAddr: '网络位地址',
    bordcastAddr: '广播地址',
    availableAddrSpace: '可用地址空间',
    ipAddressSegment: 'IP地址段',
    gatewayAddress: '网关地址',
    helpDoc: '{0}帮助文档'
  },

  equipment: {
    cpu: 'CPU',
    memory: '内存',
    disk: '磁盘',
    systemIp: '系统IP',
    manageIp: '管理IP',
    equipmentDetail: '设备详情',
    snNumber: 'SN号',
    equipmentType: '设备类型',
    assetBelonging: '资产所属',
    belongInfo: '所属信息',
    equipmentStatus: '设备状态',
    belongComputerRoom: '所属机房',
    equipmentList: '设备列表',
    locateUbit: '所在U位',
    configInfo: '配置信息',
    equipmentQuantity: '设备数量',
    helpDoc: '{0}帮助文档',
    core: '核',
    equipmentNumber: '设备编码',
    uNo: 'U数(U)',
    // 搜索placeholder
    searchPlaceholder: {
      deviceNo: '请输入设备编码进行搜索',
      snNo: '请输入SN号进行搜索',
      cabinetNo: '请输入机柜编码进行搜索'
    },
    searchPlaceholderNew: {
      deviceNo: '可输入多个设备编码搜索，用逗号分开',
      snNo: '请输入SN号进行搜索',
      cabinetNo: '请输入机柜编码进行搜索'
    }
  },

  bandWidth: {
    lineType: '线路类型',
    chargeType: '计费方式',

    bd: '带宽（出口）',
    bandWidthDetail: '带宽（出口）详情',
    relationPublicNetIp: '关联的公网IP',
    helpDoc: '{0}帮助文档',
    name: '带宽(出口)名称',
    contractBandwidth: '合同带宽',
    contractBandwidthName: '合同带宽（Mbps）',
    bandwidthName: '带宽',
    minBandwidth: '保底带宽',
    minBandwidthName: '保底带宽（Mbps）',
    minBandwidthPeak: '95峰值（IN，OUT统一计算95）',
    bandWidthDetailName: '带宽（Mbps）',
    contractMinBandwidth: '合同/保底带宽',
    inputName: '请输入带宽(出口)名称搜索',
    inputIp: '请输入关联的公网IP搜索'
  },

  ticket: {
    ticketNo: '工单编号',
    remark: '描述',
    myWork: '我的工单',
    workName: '工单名称',
    workType: '工单类型',
    setUpTime: '创建时间',
    closeTime: '关闭时间',
    submissionWork: '提交工单',
    contractEditNum: '合同编号',
    upLoadWorkTemplate: '上传工单模板',
    workDetail: '工单详情',
    workStatus: '工单状态',
    applyInfo: '申请信息',
    userPin: '用户Pin',
    clickDownload: '点击下载',
    customerUpload: '客户上传',
    systemUpload: '系统上传',
    upLoadFile: '上传文件',

    // 工单类型选择页
    assetManagement: '资产管理',
    stayTuned: '敬请期待',
    deviceChange: '设备变更',
    accessoriesNotEmpty: '附件不能为空',

    // 提交工单页
    applyCabinet: '机柜初装申请模板',
    applyCabinetDownload: '机柜初装申请模板下载',
    handleSuccess: '操作成功',
    submitWorksheetError: '提交工单失败，请重新尝试!',

    // 工单列表
    to: '至',
    exportWorksheetList: '导出全部工单列表',
    waitMeProcessed: '待我处理',
    processing: '处理中',
    complete: '全部',

    // 工单详情
    submitApplay: '提交申请',
    pending: '待审核',
    initialInstallation: '初装方案',
    verificationProgram: '方案核验',
    implementationDelivery: '实施交付',
    deliveryVerification: '交付核验',
    toBeOff: '待关单',
    completed: '已完成',
    constructioDelivery: '施工交付单（客户核验）',
    verifyConfirmTip:
      '注意：如超过3天未操作，此工单自动核验通过。请您及时处理。',
    verifyConfirm:
      '您的工单申请已经完成设备迁入，请核验交付结果，详细信息查看处理结果的迁入设备列表。',
    // 工单操作
    handleWorksheetError: '工单操作失败，请重新尝试',
    uploadFileSuccess: '文件上传成功',
    cancelReason: '取消原因',

    helpDoc: '{0}帮助文档'
  },

  overview: {
    resourceInformation: '资源信息',
    cabinetInformation: '机柜信息',
    equipmentInformation: '设备信息',
    publicNetIpInformation: '公网IP信息',
    bandWidthInformation: '带宽（出口）信息',
    cabinetTotal: '机柜',
    equipmentTotal: '设备',
    severTotal: '服务器',
    networkEquipmentTotal: '网络设备',
    storageEquipmentTotal: '存储设备',
    othersEquipmentTotal: '其他设备',
    Enabled: '已开通',
    Disabled: '未开通',
    Enabling: '开通中',
    Disabling: '关闭中',
    ipTotal: '公网IP',
    operating: '操作中',
    changing: '变更中',
    unsubscribing: '退订中',

    welcome: '欢迎使用云托管服务',
    subtitle: '为您提供专业、稳定、安全的主机托管服务，实时监控资源状态，保障业务持续运行',
    idcResourceZone: '机房资源详情',
    onlyUnexpired: '仅显示未过期资源',
    customerService: {
      title: '客户服务',
      hotLineTitle: '7*24小时热线',
      hotLinePhone: '173-1622-9792',
      hotLineDesc: '技术支持 | 故障报修 | 服务咨询',
      afterSalesManager: '专属售后经理{0}',
    },
    notice: {
      listTitle: '信息公告',
      backList: '返回消息列表',
      backAnnouncementList: '返回公告列表',
      backNoticeList: '返回通知列表',
      prevNotice: '上一篇',
      nextNotice: '下一篇',
      noPre: '已经是第一篇了',
      noNext: '已经是最后一篇了',
      jdTeam: '京东云团队',
      title: '最新公告',
      title2: '事件通知',
      networkFreezeCutoverTitle: '事件通知',
      networkFreezeCutoverListTitle: '事件通知',
      moreLink: '更多',
    },
    workList: {
      title: '我的工单',
      moreLink: '全部工单',
    },
    quickActions: {
      title: '快速提单',
    },
    monitor: {
      title: '异常报警',
      subTitle: '展示24小时以内的报警历史',
      totalAlarmRules: '报警规则',
      portAlarmCount: '端口报警',
      popAlarmCount: '出口报警',
      deviceInspectionCount: '设备巡检异常',
      idcInspectionCount: '机柜巡检异常',
    },
    resourceMonitor: {
      title: '资源监控',
      bandwidthLabel: '带宽(出口)',
      allBandwidth: '全部带宽',
      period: '周期',
      day31range: '可查询90天内的数据，最多连续查询31天数据',
      noBandwidthTip: '暂无可监控的带宽资源',
    },
    layoutDragTip: '拖动模块可调整位置',
  },

  merge: {
    basicInfo: '基本信息',
    roomName: '机房名称',
    customList: '自定义列表',
    helpDoc: '帮助文档',
    limitProblem: '如有问题，可联系在线客服',
    PermissionTip: '您尚未开通云托管服务，请联系商务开通。',
    wordCount: '{0}/256字',

    // 附件提交报错
    uploadMax5M: '上传文件大小不能超过 5MB!',
    uploadShouldBe: '上传文件只能是 .xls、.xlsx格式!',
    uploadShouldBe1: '上传文件只能是 .png、.jpg、.pdf格式!',
    uploadShouldBeOne: '只能上传一个文件，请删除重新添加!',
    uploadShouldBeTwo: '只能上传2个文件，请删除重新添加!',
    uploadError: '附件上传失败，请重新尝试!',

    // 时间选择
    lastWeek: '最近一周',
    lastMonth: '最近一个月',
    lastThreeMonth: '最近三个月',

    // 没有数据
    noData: '暂无数据',
    // 工单类型
    workType: '工单类型',
    // 工单名称
    workName: '工单名称',
    // 企业名称
    enterpriseName: '企业名称'
  },

  // 设备类型
  devicetypes: {
    type1: '服务器',
    type2: '网络设备',
    type3: '存储设备',
    type4: '其他设备'
  },

  // 机柜可视化
  cabinetVisual: {
    label: '机柜视图',
    label1: '机柜编码: {0} 房间号: {1}',
    tipDeviceNo: '设备编码: {0}',
    tipSN: 'SN: {0}',
    tipU: '所在U位: {0}'
  },

  // 话术部分
  speechcraft: {
    customlist: '请选择要显示在列表的信息，最多选择10个',
    submitWorkUp: '只能上传1个附件，附件大小不得超过5MB，支持xls,xlsx格式',
    limit: '您尚未开通云托管服务，请联系商务开通。',
    menulimit: '您尚未开通{0}，请联系商务开通。',
    sonlimit: '当前子用户无权访问该服务，请联系管理员为您添加权限',
    rolelimit: '当前角色无权访问该服务，请联系管理员为您添加权限。',
    cpuLogicTotal: 'CPU逻辑核数',
    ramTotal: '内存总容量',
    hardDiskTotal: '硬盘总容量',
    netDiskBandwidth: '网卡带宽',
    relatedIP: '关联的公网IP',

    // 工单操作部分话术
    revokeTitle: '确认要撤销工单申请吗？如进行撤销操作，请填写原因 。',
    verifyPlan:
      '您的工单申请已经完成初装方案设计，请确认初装方案，详细信息查看附件。',
    verifyPay:
      '您的工单申请已经完成初装交付，请核验交付结果，详细信息查看附件《施工交付单》,并上传客户签字盖章的施工交付单。(如有问题，请联系商务或者销售)。',
    iAgree: '我同意',
    closeTickekTitle:
      '您的工单申请已经处理完成，请确认关单，如超过7天未操作，系统将为您自动关闭。',

    // 概览页部分话术
    bandWidthUseInfo: '总带宽使用情况',
    exportResourceList: '导出全部资源列表',
    exportResourceCurrentList: '导出当前资源列表',
    lineTypeBandwidth: '线路类型：合同/保底带宽'
  },

  // placeholder提示信息框
  placeholder: {
    placeholderInput: '请输入{0}搜索，支持模糊搜索',
    placeholderInputMore: '支持多个{0}精确，单个模糊，空格分开搜索',
    placeholderSelect: '请选择{0}搜索',
    placeholderSelectMore: '请选择{0}搜索，可多选',
    cabinetNumCode: '请输入机柜编码搜索',
    dataTimePicker: '请选择创建日期范围',

    // 带宽网段部分
    ipAddressSegment: '请输入IP地址段搜索',
    ipAddress: '请输入关联的公网IP搜索',
    chooseContract: '请选择合同编号',
    chooseRemark: '请输入备注信息',
    roomName: '请选择机房名称',
    choose: '请选择',

    // 工单撤销
    revoke: '请输入撤销原因（必填）',
    verifyPlan: '请输入拒绝原因（必填）',
    verifyUploadTip:
      '可上传2个附件，每个附件大小不能超过3M，支持的格式有“jpg”、“png”、“pdf”',
    sn: '请输入SN号搜索',

    // 工单列表
    worksheetNo: '请输入工单编号搜索',
    worksheetRemark: '请输入描述搜索',
    worksheetName: '请输入工单名称搜索',

    searchMoreCabinetNo: '可输入多个机柜编码搜索，用空格分开',
    searchMoreSN: '可输入多个SN号搜索，用空格分开',
    searchMoreDeviceNo: '可输入多个设备编码搜索，用空格分开',
    start_placeholder: '开始日期',
    end_placeholder: '结束日期'
  },
  // 设备迁出
  equipmentMoveOut: {
    text: {
      yes: '是',
      no: '否',
      cancel: '取消',
      ok: '确定',
      pleaseSubmit: '请提交',
      dc: '人员入室',
      ticket: '工单',
      moveOutDate: '迁出日期',
      offShelfType: '下架方式',
      turnOff: '设备关机',
      deliveryType: '提货方式',
      deliveryPersonName: '提货人姓名',
      deliveryCertificate: '提货人证件类型',
      deliveryNo: '提货人证件号码',
      deliveryPhoneNo: '提货人电话',
      deviceInformation: '设备信息',
      emigratedDevice: '迁出设备',
      selectEmigratedDevice: '选择迁出设备',
      devicesHaveBeenSelected: '已选择{0}个设备',
      emigrationByCustomer: '自行下架',
      JDAgent: '京东代办',
      moveOutTip: '此类工单仅支持已上架的自备设备迁出'
    },
    placeholder: {
      offShelfType: '请选择下架方式',
      turnOff: '请选择关机方式',
      deliveryType: '请选择提货方式',
      deliveryPersonName: '请输入提货人姓名',
      deliveryCertificate: '请选择提货人证件类型',
      deliveryNo: '请输入提货人证件号码',
      deliveryPhoneNo: '请输入提货人电话',
      deviceOut: '请选择迁出设备',
      deviceOutDate: '请选择迁出日期',
      wrongFormatId: '请输入正确格式的证件号',
      enterId: '请输入证件号'
    }
  },
  // 设备异动
  equipmentMove: {
    text: {
      moveDate: '异动日期',
      moveType: '异动方式',
      currentCabinet: '当前机柜',
      currentUBit: '当前U位',
      targetCabinet: '迁入机柜',
      targetUBit: '迁入U位',
      chooseMove: '选择异动设备',
      moveDevice: '异动设备',
      nextStep: '下一步',
      finish: '完成',
      equipmentMove: '此类工单支持已开通的租赁设备或已上架的自备设备异动'
    },
    placeholder: {
      moveType: '请选择异动方式',
      moveDate: '请选择异动日期',
      moveDevice: '请选择异动设备',
      deviceNoRepeated: '设备编码不可重复',
      chooseInCabinet: '选择迁入机柜',
      example: '请输入 例：13-13'
    }
  },
  // 设备迁入
  equipmentMoveIn: {
    text: {
      selfEquipment: '自备',
      dialogTitle: '京东云IDC授权及设备变更操作免责条款',
      readAndAgree: '我已阅读并承诺',
      onShelfType: '上架方式',
      // 控制台
      readAndAgreeConsole: '我已阅读并同意',
      moveInDate: '迁入日期',
      batchTemplate: '批量模板',
      consumerName: '客户名称',
      consumerCode: '客户代码',
      userPin: '用户Pin',
      personnelBurglary: '人员入室',
      templateDownload: '模板下载',
      batchImport: '批量上传',
      save: '保存',
      del: '删除',
      edit: '编辑',
      deviceList: '设备列表',
      info: '提示'
    },
    speechCraft: {
      onlySelfEquipment: '此类工单仅支持自备设备迁入',
      dialogText:
        '此类工单需要客户出具免责声明，请确保线下已经跟客户沟通并通过邮件方式获取到客户提供的免责声明。',
      // 控制台
      dialogTextConsole:
        '一、京东云IDC现场授权操作服务用户告知<br/><br/>'
        + '用户在使用京东云IDC现场授权操作服务前，请务必仔细阅读本条款并同意本声明。<br/><br/>'
        + '用户通过各类方式（应用系统、邮件、电话、即时通讯软件等）使用京东云IDC现场授权操作服务的行为，都被视为已无条件接受本声明所涉及全部内容，若用户对本声明的任何条款有异议，请停止使用京东云IDC现场授权操作服务。<br/><br/>'
        + '1、     京东云IDC现场授权操作服务是指客户方授权人按双方约定的授权方式向京东云IDC发出对其托管或租用设备进行操作的要求；<br/>'
        + '2、     客户需要京东云IDC工程师操作服务前，需提前说明操作的详细信息，包括但不限于设备信息、操作内容、操作方法等，京东云工程师将按照客户需求说明完成操作；<br/>'
        + '3、     客户在需要京东云IDC工程师操作服务前，应对操作所涉及的IT设备系统应用及数据提前进行备份；<br/>'
        + '4、     在京东云IDC工程师按照客户说明方法对客户指定的设备进行操作过程中，发生对设备系统及数据的安全性、稳定性、可用性或其他性质的损坏，京东云不承担责任；<br/>'
        + '5、     京东云IDC工程师操作前不对客户指定设备的软硬件健康度负责，如发现开机系统故障或物理硬件损坏等，京东云不承担责任；<br/>'
        + '6、     如京东云IDC工程师在按客户要求操作过程中发生系统崩溃现象，京东云将积极协助客户恢复系统，但此操作不属于京东云义务，同时，由于该操作具有不可预见性，所以京东云不能保证最终系统的恢复情况及运行状况；<br/>'
        + '7、     京东云IDC工程师按用户操作完成后，请客户及时更改所提供设备系统的用户名及密码信息，同时京东云在此次操作完成后，不对所操作设备后续的系统及数据的稳定性、安全性、可用性负责；<br/>'
        + '8、     用户在不同的时间提出的针对某台设备或某项重复操作需求时，均需重新填写此授权书，授权书最终在京东云IDC服务台备案，作为客户针对此次操作的书面依据;<br/><br/>'
        + '二、京东云IDC托管设备变更服务用户告知：<br/><br/>'
        + '用户在使用京东云IDC托管设备变更服务前，请务必仔细阅读本条款并同意本声明。<br/><br/>'
        + '用户通过各类方式（应用系统、邮件、电话、即时通讯软件等）使用京东云IDC托管设备变更服务的行为，都被视为已无条件接受本声明所涉及全部内容，若用户对本声明的任何条款有异议，请停止使用京东云IDC托管设备变更服务<br/><br/>'
        + '1、     京东云IDC托管设备变更服务是指客户方授权人按双方约定的方式向京东云IDC发出对其托管或租用设备进行上架、下架及位置变更的要求；<br/>'
        + '2、     客户需要使用京东云IDC托管设备变更服务前，需提前说明此次变更服务的详细信息，包括但不限于托管机房、机柜位置、设备型号、IP地址、变更方式、网络线缆连接方式及其他要求等，京东云工程师将按照客户需求说明完成操作；<br/>'
        + '3、     京东云IDC工程师受理服务请求后会进行信息核实，内容包含机柜位置、IT设备的合规性、机柜空间\\电力的可用性等，核实确认后方可执行客户服务请求；<br/>'
        + '4、     京东云IDC工程师操作前不对IT设备的软硬件健康度负责，如开机系统故障、配置信息错误或物理硬件损坏等，京东云不承担责任；<br/>'
        + '5、     京东云IDC工程师对IT设备进行变更操作时，客户需在现场配合，IT设备变更完成后京东云IDC工程师将会对此次操作出具《设备变更确认单》作为服务凭证，客户核对无误后需签字确认，《设备变更确认单》一式两份，一份由京东云IDC进行存档，另一份交由客户存留；如客户无法到达现场，\n'
        + '《设备变更确认单》将由京东云IDC工程师发送电子版至客户邮箱，客户打印后签字确认，并以电子扫描件或传真形式发回京东云；<br/>'
        + '6、     客户IT设备如以邮寄\\快递形式运送至机房，并委托京东云IDC工程师签收时，客户需要提前告知物流承运方、承运单号、货物箱体数量、客户联系方式等信息。货物到达机房后，\n'
        + '京东云IDC工程师仅负责货物箱体数量清点及外包装验收，不对包装箱内IT设备及配件的数量和健康度负责；<br/>'
        + '7、     如客户需要进行IT设备下架操作时需在现场进行关机，如客户无法到达现场时需在IT设备下架前将IT设备远程关机，现场京东云IDC工程师在下架前确认IT设备状态。如客户\n'
        + ' 需要京东云IDC工程师采用强制关机手段将IT设备关机，京东云不对所操作的IT设备软硬件、应用系统及数据的中断和损坏负责；<br/>'
        + '8、     每次用户提出的京东云IDC托管设备变更需求仅限单次操作，用户如需要对不同的IT设备或时间提出设备变更需求时，均需重新填写此授权书，授权书最终在京东云IDC服务台备案，作为客户针对此次操作的书面依据；<br/><br/>',
      uploadFile:
        '只能上传1个附件，最大不超过5MB，支持xls,xlsx,doc,docx,jpg格式'
    },
    placeholder: {
      onShelfType: '请选择上架方式',
      customerName: '请输入客户名称',
      customerCode: '请输入客户代码',
      userPin: '请输入用户Pin',
      companyName: '请输入企业名称',
      telephone: '请输入电话',
      email: '请输入邮箱',
      idcName: '请选择机房名称',
      moveInDate: '请选择迁入日期',
      note: '内容',
      cabinetNo: '请输入机柜编码',
      assetStatus: '请选择资产所属',
      model: '请输入型号',
      brand: '请输入品牌',
      deviceIn: '请选择迁入设备',
      uNo: '请输入U数',
      uOnlyNumber: 'U数只能为数字',
      deviceType: '请选择设备类型',
      snNo: '请输入SN号',
      snCantChina: 'SN号不能为中文',
      phone: '请输入电话号码',
      correctPhone: '请输入正确格式的电话号码',
      correctEmail: '请输入正确格式的邮箱',
      deviceInDate: '请选择迁入日期',
      personIn: '请选择人员是否入室',
      snNoRepeated: 'SN号不可重复',
      onlyValid: '设备迁入仅支持已经完成初装的机柜。',
      makeSure: '请确保设备迁入审核后再运输设备，京东云不提供设备保存服务。'
    }
  },
  // 人员入室
  roomEntry: {
    uploadFileError: '附件上传失败，请重新尝试!',
    add: '添加',
    oneEditing: '请先保存当前编辑列',
    checkNumberOver: '单次提交不得超过100条',
    idCard: '身份证',
    passport: '护照',
    driverLicense: '驾驶证',
    officer: '军官证',
    checkInfo: '请检查人员入室信息',
    roomEntryList: '人员列表',
    upLoadFile: '上传模板',
    edit: '编辑',
    delete: '删除',
    save: '保存',
    roomEntry: '人员入室',
    baseInfo: '基本信息',
    worksheetType: '工单类型',
    worksheetName: '工单名称',
    customerName: '客户名称',
    customerCode: '客户代码',
    customerPin: '用户Pin',
    company: '企业名称',
    mobile: '电话',
    email: '邮箱',
    computerRoomName: '机房名称',
    applyInfo: '申请信息',
    addOne: '单个添加',
    addBatch: '批量导入',
    deleteBatch: '批量删除',
    selectRoom: '请选择',
    download: '模板下载',
    upload: '上传模板',
    uploadWarn: '只能上传1个附件，最大不超过5MB，支持xls、xlsx、csv格式',
    uploadError: '只能上传一个文件，请删除重新添加',
    uploadFileType: '上传文件格式不符合!',
    uploadFileSize: '上传文件大小不能超过 5MB!',
    consumerTypeInvalid: '客户类型为无效',
    cancel: '取消',
    submit: '提交',
    userPin: '用户pin',
    batchTemplate: '批量模板',
    entryNumbers: '总计{0}人',
    warnInfo: {
      customerName: '填一下',
      company: '请输入公司名称',
      mobile: '请输入电话',
      mobileFormat: '手机号码格式不正确',
      email: '请输入邮箱',
      emailFormat: '邮箱格式不正确',
      computerRoomName: '请选择机房',
      name: '请输入姓名',
      number: '请输入证件号码',
      phone: '请输入电话',
      startTime: '请输入开始日期',
      endTime: '请输入结束日期',
      reason: '请填写入室原因',
      certificates: '请选择证件类型',
      nullNumber: '请输入证件号码'
    },
    tableTitle: {
      name: '姓名',
      paperworkType: '证件类型',
      paperworkNumber: '证件号码',
      mobile: '电话',
      company: '公司名称',
      startTime: '进入日期',
      endTime: '结束日期',
      entryReason: '进入原因',
      brings: '携带物品',
      carInfo: '车辆信息',
      remark: '备注',
      operate: '操作'
    },
    validateInfo: {
      spacing: '进入日期和结束日期间隔不得大于31天',
      timeOrderOne: '结束时间不得早于开始时间',
      timeOrderTwo: '开始时间不得晚于结束时间',
      inputName: '请输入姓名',
      inputPhone: '请输入电话',
      wrongFormat: '你输入的身份证长度或格式错误',
      wrongRegion: '你的身份证地区非法',
      wrongDate: '身份证上的出生日期非法',
      wrongNumber: '你输入的身份证号非法',
      wrongPassport: '护照号码有误',
      wrongLicence: '驾驶证件号码有误',
      wrongMilitary: '军官证号有误'
    },
    placeholder: {
      inputName: '请输入姓名',
      choosePaperworkType: '请选择证件类型',
      inputNumber: '请输入证件号码',
      inputPhone: '请输入电话',
      inputCompony: '请输入公司名称',
      chooseIn: '请选择进入日期',
      chooseOut: '请选择结束日期',
      chooseInReason: '请输入进入原因',
      chooseBrings: '请输入携带物品',
      chooseCars: '请输入车辆信息',
      chooseRemark: '请输入备注'
    },
    addPerson: '添加人员入室信息'
  },
  // 服务支持
  serviceSupport: {
    supportTip: '此类工单不支持正在退订或正在变更中的设备',
    equipmentList: '设备列表',
    serviceSupport: '服务支持',
    personnelBurglary: '人员入室',
    isPersonIn: '请选择人员是否入室',
    trues: '是',
    falses: '否',
    pleaseSubmit: '请提交',
    ticket: '工单',
    deviceInfo: '设备信息',
    chooseDevice: '添加设备',
    uploadCheck:
      '只能上传1个附件，附件大小不得超过5MB，支持xls,xlsx,doc,docx,jpg格式',
    otherService: '请描述具体服务内容',
    networkCinfig:
      '请为设备指定IP地址、网关地址、子网掩码、DNS地址等网络配置信息，如果有多个设备，可通过附件形式添加。',
    outDeviceIn: '请描述清楚外设信息',
    networkMaintenance: '请描述清楚指定的端口信息',
    deviceCheck: '请描述清楚要查看的设备信息',
    systemReload: '内容',
    telephone: '请输入电话',
    email: '请输入邮箱',
    idcName: '请选择机房名称',
    placeholderDefault: '请填写{0}',
    inputForSearch: '请输入条件搜索',
    hasSelectDevice: '已选择{0}个设备',
    uploadShouldBe: '上传文件只能是 xls, xlsx, doc, docx, jpg 格式!',
    systemImage: '系统镜像',
    selectSystem: '请选择操作系统类型',
    searchForMoreDeviceNo: '可输入多个设备编码搜索，用逗号分开',
    searchForMoreCabinetNo: '可输入多个机柜编码搜索，用逗号分开',
    searchForMoreSNNo: '可输入多个SN号搜索，用逗号分开',
    collectionAccessories: '代收配件',
    expressCompany: '快递公司',
    trackingNumbe: '快递单号',
    choosecollectionAccessories: '请选择是否代收配件',
    inputexpressCompany: '请输入快递公司',
    inputtrackingNumbe: '请输入快递单号',
    inputRemark: '请输入描述信息',
    processResult: '处理结果',
    siteFeedback: '现场反馈',
    pleaseInput: '请输入',
    addDevice: '请添加设备',
    ticketDisclaimer: '京东云IDC现场授权操作免责条款',
    dialogTextConsole:
      '一、京东云IDC现场授权操作服务用户告知<br/><br/>'
      + '用户在使用京东云IDC现场授权操作服务前，请务必仔细阅读本条款并同意本声明。<br/><br/>'
      + '用户通过各类方式（应用系统、邮件、电话、即时通讯软件等）使用京东云IDC现场授权操作服务的行为，都被视为已无条件接受本声明所涉及全部内容，若用户对本声明的任何条款有异议，请停止使用京东云IDC现场授权操作服务。<br/><br/>'
      + '1、     京东云IDC现场授权操作服务是指客户方授权人按双方约定的授权方式向京东云IDC发出对其托管或租用设备进行操作的要求；<br/>'
      + '2、     客户需要京东云IDC工程师操作服务前，需提前说明操作的详细信息，包括但不限于设备信息、操作内容、操作方法等，京东云工程师将按照客户需求说明完成操作；<br/>'
      + '3、     客户在需要京东云IDC工程师操作服务前，应对操作所涉及的IT设备系统应用及数据提前进行备份；<br/>'
      + '4、     在京东云IDC工程师按照客户说明方法对客户指定的设备进行操作过程中，发生对设备系统及数据的安全性、稳定性、可用性或其他性质的损坏，京东云不承担责任；<br/>'
      + '5、     京东云IDC工程师操作前不对客户指定设备的软硬件健康度负责，如发现开机系统故障或物理硬件损坏等，京东云不承担责任；<br/>'
      + '6、     如京东云IDC工程师在按客户要求操作过程中发生系统崩溃现象，京东云将积极协助客户恢复系统，但此操作不属于京东云义务，同时，由于该操作具有不可预见性，所以京东云不能保证最终系统的恢复情况及运行状况；<br/>'
      + '7、     京东云IDC工程师按用户操作完成后，请客户及时更改所提供设备系统的用户名及密码信息，同时京东云在此次操作完成后，不对所操作设备后续的系统及数据的稳定性、安全性、可用性负责；<br/>'
      + '8、     用户在不同的时间提出的针对某台设备或某项重复操作需求时，均需重新填写此授权书，授权书最终在京东云IDC服务台备案，作为客户针对此次操作的书面依据;<br/><br/>',
    chooseRoomName: '请先选择机房名称',
    inputDeviceNetoff: '请描述清楚具体操作内容，并指明针对的网线',
    inputDevicePoweroff: '请描述清楚具体操作内容，并指明针对的电源线',
    shutDown: '授权关机',
    isShutDown: '请选择是否授权关机',
    replacementChangeTip:
      '此类型工单仅支持无需设备停机的在线操作，不支持退订中或变更中的设备。',
    inputCabinetView: '请描述清楚要查看的机柜信息',
    inputVerifyWiringDistance: '请描述清楚要核实的布线信息',
    inputReplacementChange:
      '请注明操作步骤概要、规范要求及相关注意事项，可通过上传文件补充说明具体信息',
    cabinetList: '机柜列表',
    cabinetInfo: '机柜信息',
    chooseCabinet: '添加机柜',
    addCabinet: '请添加机柜',
    cabinetNumCode: '机柜编码',
    roomNum: '房间号',
    cabinetSpace: '机柜空间(U)',
    cabinetType: '机柜类型',
    hasSelectCabinet: '已选择{0}个机柜',
    accessoryInfo: '配件信息',
    accessoryType: '配件类型',
    accessoryPosition: '配件位置',
    addAccessory: '请添加配件',
    cabinetA: '选择A端机柜',
    cabinetB: '选择B端机柜',
    xCabinetNumCode: '{0}端机柜编码',
    xRoomNum: '{0}端房间号',
    sameABCabinet: 'A端与B端机柜组合已存在，请重新选择',
    sameAACabinet: 'A端与B端机柜重复，请重新选择',
    checkAccessoryInfo: '请检查配件信息',
    accessoryInfoTable: '配件信息表',
    modifyRemark: '修改备注',
    chooseAccessoryType: '请选择配件类型',
    inptuAccessoryPosition: '请输入配件位置',
    other: '其他',
    hardDisk: '指定硬盘槽位信息',
    powerSupply: '指定电源槽位信息',
    opticalModule: '指定模块端口号',
    board: '指定板卡槽位信息',
    typeAndPosition: '配件信息最多支持10条',
    maxCabinet: '机柜信息最多支持100条',
    searchCabinetNo: '请输入机柜编码搜索',
    searchRoomNo: '请输入房间号搜索',
    searchDeviceNo: '请输入设备编码搜索',
    searchSNNo: '请输入SN号搜索'
  },
  // 故障提报
  faultReport: {
    faultReportTip: '此类工单不支持正在退订或正在变更中的设备',
    equipmentList: '设备列表',
    personnelBurglary: '人员入室',
    isPersonIn: '请选择人员是否入室',
    trues: '是',
    falses: '否',
    pleaseSubmit: '请提交',
    deviceInfo: '设备信息',
    chooseDevice: '添加设备',
    uploadCheck:
      '只能上传1个附件，附件大小不得超过5MB，支持xls,xlsx,doc,docx,jpg格式',
    idcName: '请选择机房名称',
    placeholderDefault: '请填写{0}',
    courierType: '代收配件',
    courierCompany: '快递公司',
    courierCode: '快递单号',
    selectCollectingAcce: '请选择代收配件',
    placeholderInputDefault: '请输入{0}',
    deviceNo: '可输入多个设备编码搜索，用逗号分开',
    remark: '请输入故障描述信息',
    computerRoomName: '请选择机房名称',
    device: '请选择设备'
  },
  // 带宽流量
  bwTraffic: {
    traffic: '带宽（出口）流量',
    name: '带宽(出口)名称',
    totalUpRealTraffic: '总上行实时流量',
    totalDownRealTraffic: '总下行实时流量',
    totalBandwidth: '总带宽',
    helpDoc: '{0}帮助文档',
    controlChart: '监控图',
    resourceInfo: '资源信息',
    controlInfo: '监控信息',
    switchInfo: '交换机信息',
    switchIP: '交换机IP',
    port: '端口号',
    upRealTraffic: '上行实时流量',
    downRealTraffic: '下行实时流量',
    relateIP: '关联的公网IP',
    IPAddress: 'IP地址',
    lineType: '线路类型',
    trafficUnit: '流量（Mbps）',
    all: '全部',
    selectDateRange: '选择查询的日期范围',
    powerTrendChart: '带宽流量趋势图',
    noPermission: '您暂未开通该功能，请联系管理员！',
    trafficDetail: '带宽（出口）流量详情',
    day31range: '（可查询90天内的数据，最多连续查询31天数据）',
    ipAndPort: '{0}&{1}'
  },
  // 报警规则
  alarm: {
    port: '端口',
    pop: '出口',
    popTip: '按照出口未读报警，包含出口下单所有端口总和。',
    alarmObject: '报警对象',
    alarmRules: '报警规则',
    rulesName: '规则名称',
    rulesDetail: '规则详情',
    resourceType: '资源类型',
    resourceName: '资源名称',
    condition: '报警条件',
    ifnameTypeName: '监控项',
    noticePeriod: '通知周期',
    notificationObject: '通知对象',
    noticeMethod: '通知方式',
    noticeMethodNotEmpty: '通知方式不能为空',
    strategyStatusName: '规则状态',
    modification: '修改',
    disable: '禁用',
    period: '统计周期',
    statisticMethod: '统计方法',
    expressionOp: '计算方式',
    use: '启用',
    alarmHistory: '报警历史',
    add: '新增报警规则',
    modificationTip: '请先启用报警规则',
    set: '设置报警规则',
    relationResource: '关联资源',
    alarmRulesSetting: '报警规则设置',
    notifyObjectSetting: '通知对象设置',
    ipAndPort: '交换机&端口号',
    addStepOneTip:
      '支持为每个交换机&端口号设置相同规则仅支持独立报警，不包含全部总和。',
    next: '下一步',
    prev: '上一步',
    finish: '完成',
    choose: '请选择{0}',
    contactsPeople: '联系人',
    contactsGroup: '联系组',
    rulesNameMessage:
      '1-32字符，只允许中文、数字、大小写字母、英文下划线“_”及中划线“-”',
    touchCount: '连续几次触发报警',
    clear: '清空',
    expressionValue: '阈值',
    expressionValueErrorTip:
      '阈值只支持数字且大于0，精度至多保留为小数点后两位',
    expressionValueErrorTipLimit: '阈值超过上限，请重新输入',
    allContactsPeople: '全部联系人',
    allContactsGroup: '全部联系组',
    selectedContactsPeople: '已选联系人',
    selectedContactsGroup: '已选联系组',
    searchName: '请输入姓名进行搜索',
    searchGroupName: '请输入联系组名称进行搜索',
    phone: '手机',
    peopleNum: '人数',
    groupName: '组名',
    contactsOptTip: '注：增加、修改联系人和联系组请在',
    contactsManager: '账户管理 - 联系人管理',
    nameDuplicated: '名称重复',
    times: '次'
  },
  // 报警历史
  alarmHistory: {
    alarmInfo: '报警信息',
    alarmTime: '报警时间',
    resourceType: '资源类型',
    resourceName: '资源名称',
    alarmCondition: '报警条件',
    alarmValue: '报警值',
    ipAndPort: '交换机IP&端口号',
    alarmObject: '报警对象',
    alarmStatus: '报警状态',
    alarmRule: '报警规则',
    alarmRuleName: '规则名称',
    ruleStatus: '规则状态',
    notificationPersion: '通知对象',
    notificationPeriod: '通知周期',
    helpDoc: '{0}帮助文档',
    alarmHistory: '报警历史',
    dataRange: '选择查询的日期范围',
    close: '关闭',
    index: '序号',
    phone: '手机',
    contactsPeople: '联系人',
    contactsGroup: '联系组',
    prompt: '提示',
    optionRule: '确认{0}报警规则：{1}?',
    contactsGroupName: '联系组名称',
    groupNumber: '成员数',
    showGroupInfo: '查看联系组人员信息请在',
    countManagement: '账户管理-联系人管理',
    toOperation: '里操作',
    more: '更多'
  },
  expressDelivery: {
    estimatedArrivalDate: '预计到货日期',
    estimatedPickupDate: '预计取货日期',
    packageList: '包裹清单',
    packageListInfo: '包裹清单列表',
    sendListInfo: '发货清单列表',
    sendList: '发货清单',
    goodsList: '货物列表',
    goodsType: '货物类型',
    goodsDesc: '货物描述',
    goodsDescPlaceholder: ' 请补充描述货物名称，品牌，型号，数量等必要信息',
    goodsDescOtherPlaceholder: ' 请补充描述货物名称，品牌，型号等必要信息',
    harvesinfo: '收货信息',
    shippingAddress: '收货地址',
    recipient: '收货人',
    sender: '寄件人',
    recipientMobile: '联系电话',
    choose: '请选择{0}',
    courier: '快递联系人',
    recipientContacts: '收货联系人',
    placeholderInputDefault: '请输入{0}',
    courierCompanyMessage: '1-32字符，只允许中文、数字、大小写字母',
    recipientCompanyMessage: '1-32字符，只允许中文、大小写字母',
    courierCodeTip: '一个工单仅支持一个快递物流单号',
    notEmpty: '{0}不能为空',
    remark: '请输入描述信息',
    courierTip: '快递取货人员需携带证明身份的证件',
    description: '描述',
    idcAddress: '机房地址',
    deliveryinfo: '发货信息',
    remarkMessage: '请输入描述信息',
    idcManagerPhone: '机房值班电话',
    maturityRange: '到货日期范围仅支持3天内',
    checkPackageListInfo: '请检查包裹清单信息',
    checkSendListInfo: '请检查包裹清单信息',
    isReceived: '是否接收',
    storageLocation: '存放位置',
    storageDesc: '存放描述',
    isSend: '是否发送',
    packageInfoLenMessage: '最多添加{0}条',
    snNoRepeat: 'SN号不能重复',
    checkNumberOver: '单次提交不得超过{0}条',
    ticketDisclaimer: '京东云IDC设备快递操作免责条款',
    dialogTextConsole:
      '一、京东云IDC机房客户设备快递服务用户告知：<br/><br/>'
      + '用户在使用京东云IDC机房客户设备快递服务前，请务必仔细阅读本条款并同意本声明。<br/><br/>'
      + '用户通过各类方式（应用系统、邮件、电话、即时通讯软件等）使用京东云IDC机房客户设备快递服务的行为，都被视为已无条件接受本声明所涉及全部内容，若用户对本声明的任何条款有异议，请停止使用京东云IDC机房客户设备快递服务。<br/><br/>'
      + '1、     京东云IDC机房客户设备快递服务是指客户方授权人按双方约定的方式向京东云IDC发出对其托管或租用设备通过第三方物流公司运送至指定地点的要求；<br/>'
      + '2、     客户需要使用京东云IDC机房客户设备快递服务前，需提前说明此次快递设备的详细信息，包括但不限于托管机房、机柜位置、设备U位、设备型号、SN号、下架时间等；另需提供第三方物流承运供应商的相关信息，含物流公司名称、承运人身份证明、运送目的地、设备保价、物流包装方式等信息，京东云工程师将按照客户需求说明将托管设备下架并交由客户指定物流承运人员；<br/>'
      + '3、     京东云IDC工程师受理服务请求后会进行信息核实，内容包含机柜位置、设备U位、设备型号、SN等内容，核实确认后方可执行客户服务请求；<br/>'
      + '4、     在对IT设备进行快递操作前，客户需要将IT设备远程关机，现场京东云IDC工程师将在设备下架前确认IT设备运行状态，如客户需要京东云IDC工程师采用强制关机手段将IT设备关机，京东云不对所操作的IT设备软硬件、应用系统及数据的中断和损坏负责；<br/>'
      + '5、     IT设备下架完成后京东云IDC工程师将会对此次操作出具《设备变更确认单》作为服务凭证，由于客户未达现场，《设备变更确认单》将由京东云IDC工程师发送电子版至客户邮箱，客户核对无误打印后签字确认，并以电子扫描件或传真形式发回京东云，《设备变更确认单》一式两份，一份由京东云IDC进行存档，另一份交由客户存留；<br/>'
      + '6、     客户IT设备在交由客户指定物流承运人员后，设备的运途追踪、完好性、运达时间等均由物流公司负责，京东云不承担相关责任；<br/>'
      + '7、     每次用户提出的京东云IDC托管设备快递服务需求仅限单次操作，用户如需要对不同的IT设备或时间提出设备快递服务需求时，均需重新填写此授权书，授权书最终在京东云IDC服务台备案，作为客户针对此次操作的书面依据；<br/>'
      + '8、     客户使用京东云IDC机房客户设备快递服务前，需要与第三方物流公司协商好价格及费用支付问题，京东云IDC工程师不负责物流议价，且不垫付任何费用;<br/><br/>'
  },
  cabinetPowerUp: {
    powerUpTime: '期望开通时间',
    powerStatus: '开通状态',
    form: {
      powerUpTime: '请选择期望开通时间'
    }
  },
  cabinetReservation: {
    IDCRoom: 'IDC机房名称',
    apply: '预留资源',
    applyTime: '预留时间',
    applyNum: '预留数量',
    addList: '加入清单',
    applyList: '已预留资源列表',
    cabinetPower: '机柜电力',
    unit: '单位',
    one: '个',
    space: '空间',
    power: '电力',
    reserveTip: '预定资源的结束时间',
    cabinetSpace: '机柜空间',
    productName: '产品名称',
    handleTips: {
      inputIDCRoom: '请输入/选择IDC机房名称',
      reserveTip: '请选择预定资源的结束时间',
      cabinetPower: '请选择机柜电力',
      cabinetSpace: '请选择机柜空间',
      reserveReq: '请选择预留需求',
      cabinetType: '请选择机柜规格'
    },
    reserveReq: '预留需求',
    cabinetType: '机柜规格'
  },
  // 机柜购买
  create: {
    text: {
      yearlyOrMonthly: '包年包月',
      regionAndAz: '地域与托管区',
      region: '地域',
      az: '托管区',
      dc: '数据中心',
      specs: '规格类型',
      cabinetType: '机型',
      spec: '规格',
      cabinetRoom: '机柜空间',
      current: '额定电流',
      buy: '机柜购买',
      buyNum: '购买量',
      buyTimeSpan: '购买时长',
      count: '购买数量',
      year: '年',
      soldOut: '售罄',
      cost: '费用',
      selectedConfig: '已选配置',
      buyNow: '立即购买',
      yearUnit: '年',
      calculating: '计算中...',
      original: '原价',
      save: '省'
    },
    hover: {
      count: '单次订单最大购买数量为10个'
    },
    help: {
      soldOut: '已售罄！',
      noCertification:
        '您购买的产品需要企业实名认证，请您通过认证后再购买此类产品。',
      goCertificate: '去认证',
      restock: '补货中!',
      contact: '咨询请联系客服400-615-1212（7*24小时）。',
      ticket: '提交工单。',
      notEnough: '资源不足，请尝试减少主机购买数量,',
      orContact: '也可以联系客服400-615-1212（7*24小时）。'
    }
  },
  cabinetPowerOff: {
    powerOffNeed: '关电原因',
    cabinetNeed: '机柜关电后继续作为客户的预留机柜',
    powerOffTime: '期望关电时间',
    powerOffTip: '关电确认',
    powerOffTips:
      '机柜上所有相关设备（服务器、网络设备等等）已物理下线或业务下线',
    powerOffTipAll:
      '关电须知：请确认关电机柜上所有相关设备（服务器、网络设备等等）已物理下线或业务下线。',
    unsubscribe: '退订资源',
    addCabinetsTip:
      '注意：请先提交设备迁出/异动工单将设备搬离机柜，仅支持选择无任何设备的机柜退租',
    applyEndTime: '预留结束时间',
    needAndRoom: '请先选择预留需求与机房名称',
    confirm: '已确认',
    notice: '关电须知',
    form: {
      powerOffNeed: '请选择关电原因',
      powerOffTime: '请选择期望关电时间',
      applyEndTime: '请选择预留结束时间',
      confirm: '请确认关电',
      applyEndTimeChecker: '预留结束时间需要大于等于期望关电时间'
    }
  },
  GeneralServices: {
    remarks: '请输入服务内容，如设备迁入、迁出，设备重启等，以及补充信息',
    count: '数量',
    deviceTip: '(非设备需求可不填写)',
    snNoRepeated: 'SN号不可重复'
  },
  equipmentUnsubscribe: {
    unsubscribeTime: '期望退订时间',
    dataBackup: '数据备份确认',
    dataErasure: '数据擦除确认',
    dataBackupNotice:
      '客户自行将退订相关设备（服务器、网络设备等）的业务数据完成备份。',
    dataErasureNotice:
      '客户自行将退订相关设备（服务器、网络设备等）的业务数据完成擦除。',
    unsubscribeNotice:
      '退订须知：请确认退订相关设备（服务器、网络设备等等）已自行完成数据备份并擦除，如有数据丢失，京东云不承担责任。',
    form: {
      confirm: '请确认',
      unsubscribeTime: '请选择期望退订时间',
      outsideIDC: '请输入外部机房地址',
      outsideContact: '请输入外部机房联系人',
      outsideMobile: '请输入外部机房联系电话'
    },
    outsideIDC: '外部机房地址',
    outsideContact: '外部机房联系人',
    outsideMobile: '外部机房联系电话',
    chooseDevice: '选择退订设备'
  },
  deviceOpen: {
    jiaofuziyuan: '交付资源',
    jiaofuziyuanList: '交付资源列表',
    addjiaofuziyuan: '添加交付资源',
    requestAddjiaofuziyuan: '请添加交付资源',
    addDisk: '添加磁盘',
    chanpinguige: '产品规格',
    xuanzechanpin: '选择产品',
    config: '配置',
    wulicpu: '物理CPU',
    storage: '内存',
    disk: '磁盘',
    diskArray: '阵列卡',
    network: '网卡',
    gpu: 'GPU',
    diskType: '类型',
    diskVolume: '单容量',
    configRemark: '配置要求',
    discription: '请输入需要的一种产品规格，如需多种规格，请逐条添加至交付清单',
    jiaofushuliang: '交付数量',
    addList: '加入清单',
    selectConfig: '请至少选择1个磁盘'
  },
  menu: {
    resource: '资源管理',
    ticket: '工单管理',
    monitor: '资源监控',
    alarm: '报警管理',
    consumption: '消费管理',
  },
  rowIdcs: {
    formal: '正式',
    reserved: '预留',
    sum: '总计',
    own: '自备',
    lease: '租赁',
    ipv4: 'IPv4',
    ipv6: 'IPv6',
    dynamicBGP: '动态',
    staticBGP: '静态',
    announcedBGP: '代播',
    telecom: '电信单线',
    unicom: '联通单线',
    mobile: '移动单线',
    directConnect: '专线',
    bareFibre: '裸光纤',
    transmissionLink: '传输链路',
    power: '电力',
    electricity: '电流',
    idcPort: '机房端口',
    devicePort: '设备端口',
    accessory: '配件',
    cable: '线缆',
    vas: '增值服务',
    oneTimeService: '一次性付费服务',
    reservationFee: '预占费',
    unitText: {
      unit: '个',
      paragraph: '段',
      mbyte: 'Mbps',
      km: '公里',
      strip: '条',
      ampere: 'A',
      chip: '对芯(条)',
      item: '项',
      batch: '批(次)'
    }
  }
};



// WEBPACK FOOTER //
// ./src/lib/i18n-zh-CN.js